import { Api } from '@/src/store/api'

export const SchedulePaymentsApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /card/:cardAccountId/payments/schedules': {
      invalidatesTags: ['GET /card/:cardAccountId/payments/schedules'],
    },
    'DELETE /card/:cardAccountId/payments/schedules/:scheduleId': {
      invalidatesTags: ['GET /card/:cardAccountId/payments/schedules'],
    },
  },
})
